import React, { useState, useEffect } from "react";
import NavbarGuest from "./NavbarGuest";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import axios from "../api/axios";
import { isBlockedEmailDomain, checkEmailRegex } from "./utilities/emailUtilis";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  useEffect(() => {
    if (error) {
      setError("");
    }
  }, [email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!checkEmailRegex(email)) {
      setError("Please enter a vlaid email.");
      return;
    }
    if (isBlockedEmailDomain(email)){
      setError("Webmails are not allowed. Please use your organisation email.");
      return;
    }
    setLoading(true);
    const result = await forgotpassword(email);
    if (result.success) {
      setEmailSent(true);
      setLoading(false);
    } else {
      setError(
        result.error || "An unexpected error occurred. Please try again"
      );
      setLoading(false);
    }
  };

  const forgotpassword = async (email) => {
    try {
      // Get CSRF token first
      await axios.get("/sanctum/csrf-cookie", {});
      const res = await axios.post("/forgotpassword", {
        email,});
        return {
          success: res.data?.success,
          message: res.data?.message || "Reset link sent successfully",
        };
    
      } catch (error) {
        let message = "Something went wrong. Please try again.";
    
        // validation errors (422)
        if (error.response?.status === 422) {
          const errors = error.response.data.message;
          if (errors) {
            message = Object.values(errors)[0][0];
          }
        }
    
        // custom backend errors (400, 404)
        else if (error.response?.data?.error) {
          message = error.response.data.error;
        }
    
        // backend message (500)
        else if (error.response?.data?.message) {
          message = error.response.data.message;
        }
    
        // Network / Axios error
        else if (error.message) {
          message = error.message;
        }
    
        return {
          success: false,
          error: message,
        };
      }
  };

  return (
    <>
      <section className="fullScreenLayout">
        <NavbarGuest />
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            padding: "20px",
            flex: "1",
          }}
        >
          <div style={{ padding: "3rem 1.5rem", maxWidth: "400px" }}>
            <p className="text-center login">Forgot Password</p>
            <p
              className={`text-center para ${emailSent ? "success-text" : ""}`}
            >
              {!emailSent
                ? "Please enter the email address associated with your account to reset your password."
                : "We have sent a reset password link to your email address. Please check your inbox."}
            </p>
            {!emailSent && (
              <>
                {error && <p className="error-text text-center">{error}</p>}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email">Email*</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn w-100 text-white"
                    style={{ backgroundColor: "#0061BB" }}
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Submit"}
                  </button>
                  <br />
                </form>
              </>
            )}
            {emailSent && (
              <p className="text-center mt-2">
                click here for <Link to="/login">login</Link>
              </p>
            )}
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}
